import React, { FC, useEffect, useState } from "react";
import { useConfig, useNotification, useOidc } from "@revenuewell/front-end-bundle";
import PaymentService from "apps/wrapper/src/services/payment-service/payment-service";
import { CareCreditIHSTokens } from "apps/wrapper/src/types/payment/care-credit";
import { Dialog, DialogContent } from "apps/wrapper/src/components/shared/dialog/dialog.styles";
import { CardActions, CardContent, LinearProgress } from "@mui/material";
import { Card } from "../../../../patient-profile-page.styles";
import { SecondaryButton } from "apps/wrapper/src/components/shared/buttons";

interface PresentOfferModalProps {
  patientId: number;
  isOpen: boolean;
  onClose: () => void;
}

export const PresentOfferModal = ({ isOpen, patientId, onClose }: PresentOfferModalProps) => {
  const { config } = useConfig();
  const { oidcService } = useOidc();
  const { showError } = useNotification();
  const [loading, setLoading] = useState(true);
  const [ihsTokens, setIhsTokens] = useState<CareCreditIHSTokens>(null!);
  const paymentService = new PaymentService(config, oidcService);

  const fetchIhsTokens = async (patientIdParam: number) => {
    try {
      const response = await paymentService.getCareCreditPreApprovalIHSTokens(patientIdParam);
      setIhsTokens(response);
    } catch {
      showError('Failed to fetch IHS tokens');
    }
  }

  useEffect(() => {
    if (isOpen && patientId) fetchIhsTokens(patientId);
  }, [patientId, isOpen]);

  const handleClose = () => {
    setIhsTokens(null!);
    setLoading(true);
    onClose();
  }

  const { sessionId, referenceId } = ihsTokens || {};

  return (
    <Dialog open={isOpen} maxWidth={false}>
      <DialogContent>
        <Card>
          <CardContent style={{ minWidth: '820px', minHeight: '540px' }}>
            {loading && <LinearProgress />}
            {sessionId && referenceId && (
              <iframe
                title="CareCredit Iframe"
                sandbox="allow-modals allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox "
                style={{ minWidth: '820px', minHeight: '940px', border: 'none', marginBottom: '20px' }}
                src={`${config.careCredit.url}?code=${sessionId}&rfID=${referenceId}&iframeFlag=Y`}
                onLoad={() => setLoading(false)}
              />
            )}
          </CardContent>
          <CardActions>
            <SecondaryButton onClick={handleClose}>CLOSE</SecondaryButton>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
};
